module["exports"] = [
  "Diesel",
  "Electric",
  "Gasoline",
  "Hybrid"
];
